import {
  CREATE_ONLY_OPTIONS,
  DELETE_ONLY_OPTIONS,
} from '@/consts/subscription.consts';
import { showNotification } from '@mantine/notifications';
import { Encounter, Media } from '@medplum/fhirtypes';
import { useMedplum, useSubscription } from '@medplum/react';
import { useCallback, useEffect, useState } from 'react';

export const useEncounterMedia = (encounter?: Encounter) => {
  const medplum = useMedplum();
  const [images, setImages] = useState<Media[]>([]);
  const [loading, setLoading] = useState(false);

  const loadImages = useCallback(async () => {
    if (!encounter?.id) {
      return;
    }
    setLoading(true);
    try {
      const result = await medplum.search(
        'Media',
        `encounter=Encounter/${encounter.id}`
      );
      const mediaResources =
        result.entry?.map((e) => e.resource as Media) || [];
      setImages(mediaResources);
    } catch (error) {
      console.error('Failed to load media:', error);
    } finally {
      setLoading(false);
    }
  }, [medplum, encounter?.id]);

  useEffect(() => {
    loadImages();
  }, [loadImages]);

  //----------------------------------------------------------------------------
  useSubscription(
    `Media?encounter=Encounter/${encounter?.id}`,
    async (bundle) => {
      const media = bundle.entry?.find(
        (m) => m.resource?.resourceType === 'Media'
      )?.resource as Media | undefined;

      if (!media?.id) {
        return;
      }

      try {
        const fullMedia = await medplum.readResource('Media', media.id);
        setImages((prev) => {
          return [...prev, fullMedia];
        });
      } catch (err) {
        showNotification({
          color: 'red',
          title: 'Failed to load media',
          message: err instanceof Error ? err.message : String(err),
        });
      }
    },
    CREATE_ONLY_OPTIONS
  );
  //----------------------------------------------------------------------------
  useSubscription(
    `Media?encounter=Encounter/${encounter?.id}`,
    async (bundle) => {
      const media = bundle.entry?.find(
        (e) => e.resource?.resourceType === 'Media')?.resource as Media | undefined;

      if (!media?.id) {
        return;
      }

      setImages((prev) => prev.filter((m) => m.id !== media.id));
    },
    DELETE_ONLY_OPTIONS
  );

  return { images, loading, reload: loadImages };
};
